import Vue from 'vue';

/**
 * Globa Vue Bus for across app events
 */
export const EventBus = new Vue();